import { useState } from 'react';
import { Controller, type Control, type FieldErrors } from 'react-hook-form';

import { PicturesUpload } from '@common/ui/PicturesUpload';
import { Heading } from '@common/ui/typography/Heading';
import { Paragraph } from '@common/ui/typography/Paragraph';

import {
  UNKNOWN_PHOTO_ERROR_MESSAGE,
  useUploader,
} from '@entities/profile/hooks/useUploader';

import type { SignUpFormData } from '../../SignUp';

interface PicturesProps {
  control: Control<SignUpFormData>;
  errors: FieldErrors<SignUpFormData>;
}

export const Pictures = ({ control, errors }: PicturesProps) => {
  const [error, setError] = useState<string>();

  const uploader = useUploader({
    onUnknownError: () => {
      console.log('Unknown error in Pictures component');
      setError(UNKNOWN_PHOTO_ERROR_MESSAGE);
    },
    onFileTooLarge: ({ message }) => {
      console.log('File too large in Pictures component:', message);
      setError(message);
    },
  });

  return (
    <>
      <Heading level={2} style={{ textAlign: 'center' }}>
        Ваши фотографии
      </Heading>
      <Paragraph style={{ textAlign: 'center', marginTop: -20 }}>
        Добавьте от 1 до 3 фотографий. Нажмите на фотографию, чтобы сделать ее
        главной
      </Paragraph>

      <Controller
        control={control}
        name="pictures"
        render={({ field }) => (
          <PicturesUpload
            maxNumber={3}
            error={errors.pictures?.message?.toString() || error}
            onChange={(v) => {
              field.onChange(v);
              if (v && v.length > 0) {
                setError(undefined);
              }
            }}
            upload={uploader}
          />
        )}
      />

      <Paragraph variant="secondary" style={{ textAlign: 'center' }}>
        (Загружайте только реальные)
      </Paragraph>
    </>
  );
};
